module.exports = __webpack_public_path__ + "static/img/1.2f20e82.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/1.png
// module id = 5h2h
// module chunks = 1